export default "__VITE_ASSET__66ca0065__"